/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvaluationDimension } from './evaluationDimension';

/**
 * Dictionary of evaluation dimensions with their configurations including weights
 */
export type TenantPublicGradingSettingsEvalDimensions = { [key: string]: EvaluationDimension };
